/**
 * Popup d’abord (Chrome Android, bureau…) : la session reste sur pages.dev.
 * Redirect seulement quand la popup est peu fiable (Safari iOS natif).
 * @see https://firebase.google.com/docs/auth/web/redirect-best-practices
 */
export function isPwaStandalone() {
  if (typeof window === 'undefined') return false
  return (
    window.matchMedia('(display-mode: standalone)').matches
    || window.matchMedia('(display-mode: fullscreen)').matches
    || window.matchMedia('(display-mode: minimal-ui)').matches
    || window.navigator.standalone === true
  )
}

function isIosDevice() {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  return (
    /iPhone|iPad|iPod/i.test(ua)
    || (navigator.maxTouchPoints > 1 && /Macintosh/i.test(ua))
  )
}

/** true → signInWithPopup en premier (reconnexion fiable sur Chrome / Android). */
export function preferGoogleSignInPopup() {
  if (typeof navigator === 'undefined') return true
  const ua = navigator.userAgent || ''
  if (!isIosDevice()) return true
  // iOS : Chrome/Firefox/Edge iOS → tenter popup
  if (/CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua)) return true
  // Safari iOS (navigateur ou PWA) → redirect
  return false
}

/** @deprecated Préférer preferGoogleSignInPopup */
export function shouldUseGoogleSignInRedirect() {
  return !preferGoogleSignInPopup()
}
